import { useState, useEffect } from "react";
import AdvanceSearchInput from "./AdvanceSearchInput";
import DropDown from "../UI/DropDown";
import { AddIcon } from "../UI/AddIcon";
import { RemoveIcon } from "../UI/RemoveIcon";
import AdvanceSearchTip from "../UI/AdvanceSearchTip";
const dropdownOptions = [
  { label: "anywhere", type: "*" },
  { label: "title", type: "itemTitle" },
  { label: "author", type: "author" },
  { label: "publication", type: "publications" },
];
const labelHandler = (type) => {
  const mapping = {
    "*": "Anywhere",
    itemTitle: "Title",
    author: "Author",
    publications: "publication",
  };
  return mapping[type];
};

const defaultObj = { textValue: "", type: "*" };
const initialInput = {
  input_0: { ...defaultObj },
};
const clearUp = () => {
  initialInput.input_0 = { ...defaultObj };
};
const AdvanceSearch = ({ label, setAdvanceSearch, closeSearch, advanceSearchQuery }) => {
  const [nOfInputs, setNOfInputs] = useState(advanceSearchQuery ? advanceSearchQuery : initialInput);
  const [showTips, setShowTips] = useState(false);

  const handleSearchInput = (val, i) => {
    const prevInputs = { ...nOfInputs };
    prevInputs[i].textValue = val;
    setNOfInputs(prevInputs);
  };
  const addInput = (i) => {
    const prevInputs = { ...nOfInputs };
    prevInputs[`input_${i + 1}`] = { ...defaultObj };
    setNOfInputs(prevInputs);
  };
  const deleteInput = (id) => {
    const prevInputs = { ...nOfInputs };
    delete prevInputs[id];
    setNOfInputs(prevInputs);
  };
  const setType = (type, i) => {
    const prevInputs = { ...nOfInputs };
    prevInputs[i].type = type;
    setNOfInputs(prevInputs);
  };
  const handleSave = () => {
    setAdvanceSearch(nOfInputs);
    clearUp();
  };
  const handleClose = () => {
    closeSearch();
    clearUp();
  };
  useEffect(() => {
    if(advanceSearchQuery) setNOfInputs({...advanceSearchQuery})
    // eslint-disable-next-line
  }, []);
  // advanceSearchQuery
  return (
    <div className="w-full h-screen fixed top-0 left-0 bg-white px-10 flex flex-col z-50 overflow-y-auto">
      <div className="w-full uppercase font-bold text-primary border-b-4 border-primary flex flex-row justify-between py-5">
        <div className="brand-font uppercase">Advanced search</div>
        <div
          className="text-black cursor-pointer brand-font uppercase"
          onClick={handleClose}
        >
          CLOSE
        </div>
      </div>
      <div className="w-full h-full flex flex-col lg:flex-row grow">
        <div className="w-full lg:w-3/4 h-full flex flex-col overflow-y-auto">
          <div className="flex flex-row w-full mb-2 text-left text-primary mt-4">
            <div className="w-1/3 lg:w-1/4 brand-font uppercase">Field</div>
            <div className="grow ml-4 brand-font uppercase">Term</div>
          </div>
          {Object.keys(nOfInputs).map((id, index) => (
            <div
              className="flex flex-row w-full mb-4 "
              key={"advancesearchItem-" + id}
            >
              <div className="w-1/3 lg:w-1/4">
                <DropDown
                  selection={nOfInputs[id].type}
                  selectionLabel={labelHandler(nOfInputs[id].type)}
                  placeholder={"Select"}
                  values={dropdownOptions}
                  setSelection={setType}
                  id={id}
                />
              </div>
              <div className="grow border-primary border-2 ml-4 px-2">
                <AdvanceSearchInput setField={handleSearchInput} inputId={id} existingInput={nOfInputs[id].textValue}/>
              </div>
              <div className="w-20 flex flex-row items-center ml-4">
                {index + 1 === Object.keys(nOfInputs).length ? (
                  <div className="mr-2">
                    <AddIcon clickAction={() => addInput(index)} />
                  </div>
                ) : null}
                {index !== 0 ? (
                  <RemoveIcon
                    className="ml-2"
                    clickAction={() => deleteInput(id)}
                  />
                ) : null}
              </div>
            </div>
          ))}
          <div
            className="lg:hidden underline font-bold mb-2 text-xs cursor-pointer hover:opacity-50 "
            onClick={() => setShowTips(!showTips)}
          >
            {showTips ? "Close tips" : "Show tips"}
          </div>
          {showTips ? <AdvanceSearchTip /> : null}

          <div className="w-full pr-[94px] mt-auto mb-4 ">
            <button
              className="max-lg:mx-auto w-full bg-primary h-10 brand-font uppercase text-white hover:bg-white hover:text-primary border-primary border-2"
              onClick={handleSave}
            >
              Search
            </button>
          </div>
        </div>
        <div className="max-lg:hidden w-1/4">
          <AdvanceSearchTip />
        </div>
      </div>
    </div>
  );
};
export default AdvanceSearch;
